// @ts-ignore
export * as Turbo from '@hotwired/turbo';

// @ts-ignore
Turbo.session.drive = false;